export default __webpack_public_path__ + "static/media/roadmap_footer.9d639ae4.png";